import React from 'react';
import { CheckCircle2, X } from 'lucide-react';
export function Differentiation() {
  const comparisons = [{
    generic: 'Parte por el diseño',
    bitzen: 'Parte por la evaluación estratégica'
  }, {
    generic: 'Vende una página web',
    bitzen: 'Construye un canal de ventas ecommerce'
  }, {
    generic: 'Se enfoca en la estética',
    bitzen: 'Se enfoca en conversión, operación y medición'
  }, {
    generic: 'No siempre considera la operación',
    bitzen: 'Prepara la tienda para pagos, despacho, catálogo y seguimiento'
  }, {
    generic: 'Te entrega un sitio estático',
    bitzen: 'Crea una base para vender, medir y crecer'
  }, {
    generic: 'Compite por precio',
    bitzen: 'Compite por criterio, estructura e implementación'
  }];
  return <section className="relative py-16 md:py-24 bg-navy-950 text-white overflow-hidden" data-id="element-70">
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 via-navy-950 to-navy-900" data-id="element-71"></div>
      <div className="absolute top-1/2 right-0 w-[500px] h-[500px] bg-accent/15 blur-[150px] rounded-full -translate-y-1/2" data-id="element-72"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-75">
            No es una web más. Es un canal online construido con{' '}
            <span className="text-accent" data-id="element-76">lógica comercial.</span>
          </h2>
          <p className="text-lg text-slate-300" data-id="element-77">
            La diferencia entre una agencia web genérica y BitzenEscala™ no
            está en el diseño. Está en el enfoque.
          </p>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-78">
          {/* Desktop Table */}
          <div className="hidden md:block bg-navy-900/60 backdrop-blur-sm rounded-3xl border border-white/10 overflow-hidden shadow-glow" data-id="element-79">
            <div className="grid grid-cols-2 bg-navy-950/50" data-id="element-80">
              <div className="p-6 text-center font-heading font-bold text-slate-400 text-xl border-r border-white/5" data-id="element-81">
                Agencia web genérica
              </div>
              <div className="p-6 text-center font-heading font-bold text-accent text-xl bg-accent/5" data-id="element-82">
                BitzenEscala™
              </div>
            </div>

            <div className="divide-y divide-white/5" data-id="element-83">
              {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-84">
                  <div className="p-6 flex items-center gap-3 border-r border-white/5 text-slate-400" data-id="element-85">
                    <X className="w-5 h-5 shrink-0 opacity-50" data-id="element-86" />
                    <span data-id="element-87">{row.generic}</span>
                  </div>
                  <div className="p-6 flex items-center gap-3 text-white font-medium bg-accent/5" data-id="element-88">
                    <CheckCircle2 className="w-5 h-5 text-accent shrink-0" data-id="element-89" />
                    <span data-id="element-90">{row.bitzen}</span>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Mobile Stacked Cards */}
          <div className="md:hidden space-y-6" data-id="element-91">
            <div className="bg-navy-900/60 backdrop-blur-sm rounded-2xl border border-white/5 p-6" data-id="element-92">
              <h3 className="font-heading font-bold text-slate-400 text-xl mb-6 text-center" data-id="element-93">
                Agencia web genérica
              </h3>
              <div className="space-y-4" data-id="element-94">
                {comparisons.map((row, i) => <div key={i} className="flex items-start gap-3 text-slate-400 text-sm" data-id="element-95">
                    <X className="w-5 h-5 shrink-0 opacity-50" data-id="element-96" />
                    <span data-id="element-97">{row.generic}</span>
                  </div>)}
              </div>
            </div>

            <div className="bg-navy-900/80 backdrop-blur-sm rounded-2xl border border-accent/40 p-6 shadow-glow relative overflow-hidden" data-id="element-98">
              <div className="absolute inset-0 bg-accent/5" data-id="element-99"></div>
              <h3 className="relative font-heading font-bold text-accent text-xl mb-6 text-center" data-id="element-100">
                BitzenEscala™
              </h3>
              <div className="relative space-y-4" data-id="element-101">
                {comparisons.map((row, i) => <div key={i} className="flex items-start gap-3 text-white font-medium text-sm" data-id="element-102">
                    <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-103" />
                    <span data-id="element-104">{row.bitzen}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}